export const socialLinks = {
  github: "https://github.com/MucahitTunel",
  linkedin: "https://www.linkedin.com/in/m%C3%BCcahit-t%C3%BCnel-7087a6151/",
  email: "mucahit.tunel102@gmail.com"
}; 